export default __webpack_public_path__ + "static/media/slide_02.f8a34937.png";